import Color from 'color';
import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { ifNotProp, ifProp } from 'styled-tools';
import { FormTemplate } from 'api/form/types';
import { ProductiveHeading05, BodyShort01 } from 'components/styles';

type Props = Pick<FormTemplate, 'name' | 'description' | 'formTheme'>;

const FormHeaderContentWrapper = styled.div<{
  titleBarColor: string;
  headerColor: string;
  isDarkBackgroundColor: boolean;
  headerImage?: string;
}>`
  border-top: 8px solid ${({ titleBarColor }) => titleBarColor};
  padding: var(--spacing-06);
  background: ${({ headerColor }) => headerColor};

  ${ifProp(
    'isDarkBackgroundColor',
    css`
      color: var(--white-100);
    `,
  )};

  ${ifNotProp(
    'headerImage',
    css`
      border-radius: 10px 10px 0px 0px;
    `,
  )};
`;

const HeaderImage = styled.div`
  width: 100%;
  height: 168px;
  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;
const FormHeaderTitle = styled.div`
  ${ProductiveHeading05};
`;
const FormHeaderDesc = styled.div`
  ${BodyShort01};
  opacity: 0.8;
  margin-top: var(--spacing-03);
`;

export const FormHeader: FC<Props> = ({ name, description, formTheme }) => {
  return (
    <div>
      {formTheme.headerImage && (
        <HeaderImage>
          <img src={formTheme.headerImage} alt="form_header_image" />
        </HeaderImage>
      )}
      <FormHeaderContentWrapper
        titleBarColor={formTheme.titleBarColor}
        headerColor={formTheme.headerColor}
        isDarkBackgroundColor={Color(formTheme.headerColor).isDark()}
        headerImage={formTheme.headerImage}
      >
        <FormHeaderTitle>{name}</FormHeaderTitle>
        <FormHeaderDesc>{description}</FormHeaderDesc>
      </FormHeaderContentWrapper>
    </div>
  );
};
